import React, { useState } from "react";
import { Card } from "./BiUi";

const sortClasses = (a, b) => {
  const hierarchy = {
    "Nursery": 1, "LKG": 2, "HKG": 3,
    "1st": 10, "2nd": 20, "3rd": 30, "4th": 40, "5th": 50,
    "6th": 60, "7th": 70, "8th": 80, "9th": 90, "10th": 100,
    "11th": 110, "12th": 120
  };
  const getRank = (name) => {
    if (!name) return 999;
    const key = Object.keys(hierarchy).find(h => name.startsWith(h));
    return key ? hierarchy[key] : 500;
  };
  const rankA = getRank(a);
  const rankB = getRank(b);
  if (rankA !== rankB) return rankA - rankB;
  return String(a).localeCompare(String(b), undefined, { numeric: true });
};

const badge = (p) => (p >= 75 ? "bg-emerald-100 text-emerald-700" : p >= 50 ? "bg-amber-100 text-amber-700" : "bg-rose-100 text-rose-700");

/** Student Performance Matrix: full (untruncated) list, search by name, lowest attendance first, 360° action. */
export function StudentTable({ students, onPick }) {
  const [q, setQ] = useState("");
  const [asc, setAsc] = useState(true);
  const list = (students || [])
    .filter((s) => !q.trim() || `${s.name || ""} ${s.rollNumber || ""}`.toLowerCase().includes(q.trim().toLowerCase()))
    .sort((a, b) => (asc ? a.attendancePct - b.attendancePct : b.attendancePct - a.attendancePct)
      || sortClasses(a.classId, b.classId) || String(a.name).localeCompare(String(b.name)));
  const th = "sticky top-0 z-10 border-b border-slate-200 bg-slate-50 py-3 text-xs font-bold uppercase tracking-wider text-slate-600";
  return (
    <Card title="Student Performance Matrix" subtitle={`${list.length} of ${(students || []).length} students • lowest attendance first`}
      right={<input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search student name / roll no"
        className="w-64 rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-500" />}>
      <div className="max-h-[75vh] overflow-auto">
        <table className="w-full border-separate border-spacing-0 text-left text-sm">
          <thead>
            <tr>
              <th className={`${th} pl-4`}>Roll No / Student Name</th>
              <th className={th}>Class</th>
              <th className={`${th} cursor-pointer select-none`} onClick={() => setAsc(!asc)}>Attendance % {asc ? "▲" : "▼"}</th>
              <th className={th}>Diary / Homework %</th>
              <th className={th}>Exam / Marks Index</th>
              <th className={`${th} pr-4 text-right`}>Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {list.map((s) => (
              <tr key={`${s.classId}-${s.studentId}`} className="group transition-colors hover:bg-slate-50">
                <td className="py-3 pl-4 font-bold text-slate-900">
                  <span className="mr-2 text-xs font-semibold text-slate-400">{s.rollNumber || "-"}</span>{s.name}
                </td>
                <td className="py-3 font-semibold text-slate-600">{s.classId}</td>
                <td className="py-3">
                  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-black ${badge(s.attendancePct)}`}>{s.attendancePct}%</span>
                </td>
                <td className="py-3 font-semibold text-slate-500">{s.homeworkPct == null ? "-" : `${s.homeworkPct}%`}</td>
                <td className="py-3 font-semibold text-slate-500">{s.examPercent == null ? "-" : `${s.examPercent}%`}</td>
                <td className="py-3 pr-4 text-right">
                  <button onClick={() => onPick({ classId: s.classId, studentId: s.studentId })}
                    className="rounded-lg bg-sky-600 px-3 py-1 text-xs font-bold text-white hover:bg-sky-700">360° Profile</button>
                </td>
              </tr>
            ))}
            {!list.length && <tr><td colSpan={6} className="py-10 text-center text-sm font-medium text-slate-400">No students match.</td></tr>}
          </tbody>
        </table>
      </div>
    </Card>
  );
}

